'use strict';

var _ = require('lodash');
var AlertParametersFactory = function AlertParametersFactory(constants, SearchCriteriaRule) {
  /*
   * SEARCH CRITERIA PARAMETERS
   */
  function legCabinCriteria(entityData) {
    return [new SearchCriteriaRule({
      field: 'flightId',
      operator: '=',
      leftOperand: entityData.flightId
    }), new SearchCriteriaRule({
      field: 'legs.legId',
      operator: '=',
      leftOperand: entityData.legId
    }), new SearchCriteriaRule({
      field: 'legs.legCabins.cabinCode',
      operator: '=',
      leftOperand: entityData.cabinCode
    })];
  }
  function legClassCriteria(entityData) {
    var filters = legCabinCriteria(entityData);
    filters.push(new SearchCriteriaRule({
      field: 'legs.legCabins.legClasses.className',
      operator: '=',
      leftOperand: entityData.className || entityData.segmentClass
    }));
    return filters;
  }
  function segmentClassCriteria(entityData) {
    return [new SearchCriteriaRule({
      field: 'segments.segmentId',
      operator: '=',
      leftOperand: entityData.segmentId
    }), new SearchCriteriaRule({
      field: 'segments.segmentClasses.className',
      operator: '=',
      leftOperand: entityData.segmentClass
    })];
  }
  function serviceCriteria(entityData) {
    return [new SearchCriteriaRule({
      field: 'serviceId',
      operator: '=',
      leftOperand: entityData.serviceId
    }), new SearchCriteriaRule({
      field: 'serviceClassPointOfSales.classGroup',
      operator: '=',
      leftOperand: entityData.classGroup
    }), new SearchCriteriaRule({
      field: 'serviceClassPointOfSales.className',
      operator: '=',
      leftOperand: entityData.className
    }), new SearchCriteriaRule({
      field: 'serviceClassPointOfSales.significantPOS',
      operator: '=',
      leftOperand: entityData.significantPOS
    })];
  }
  function serviceManagementCriteria(entityData) {
    return [new SearchCriteriaRule({
      field: 'serviceId',
      operator: '=',
      leftOperand: entityData.serviceId
    })];
  }
  function marketCriteria(entityData) {
    return [new SearchCriteriaRule({
      field: 'origin',
      operator: '=',
      leftOperand: _.split(entityData.market, '-')[0]
    }), new SearchCriteriaRule({
      field: 'destination',
      operator: '=',
      leftOperand: _.split(entityData.market, '-')[1]
    }), new SearchCriteriaRule({
      field: 'departureDate',
      operator: '=',
      leftOperand: entityData.departureDate
    }), new SearchCriteriaRule({
      field: 'pointOfSales.posName',
      operator: '=',
      leftOperand: entityData.posName
    })];
  }
  function marketProductCriteria(entityData) {
    return [new SearchCriteriaRule({
      field: 'marketDemandId',
      operator: '=',
      leftOperand: entityData.marketDemandId
    }), new SearchCriteriaRule({
      field: 'classGroups.classGroupName',
      operator: '=',
      leftOperand: entityData.classGroup
    }), new SearchCriteriaRule({
      field: 'classGroups.posName',
      operator: '=',
      leftOperand: entityData.posName
    })];
  }

  /*
   * ADDITIONAL REQUEST PARAMETERS
   */
  function legCabinParams(entityData) {
    return {
      legId: entityData.legId,
      cabinCode: entityData.cabinCode
    };
  }
  function legClassParams(entityData) {
    return {
      legId: entityData.legId,
      cabinCode: entityData.cabinCode,
      className: entityData.className || entityData.segmentClass
    };
  }
  function segmentClassParams(entityData) {
    return {
      segmentId: entityData.segmentId,
      segmentClass: entityData.segmentClass
    };
  }
  function serviceClassParams(entityData) {
    return {
      classGroupName: entityData.classGroup,
      className: entityData.className,
      significantPos: entityData.significantPOS
    };
  }
  function marketPointOfSaleParams(entityData) {
    return {
      pointOfSale: entityData.posName
    };
  }
  function marketClassGroupParams(entityData) {
    return {
      classGroupName: entityData.classGroup,
      pointOfSale: entityData.posName
    };
  }
  var getSearchCriteria = function getSearchCriteria(mode, entityData) {
    if (mode === constants.CABIN_MODE) {
      return legCabinCriteria(entityData);
    } else if (mode === constants.CLASS_MODE) {
      return legClassCriteria(entityData);
    } else if (mode === constants.SEGMENT_CLASS_MODE) {
      return segmentClassCriteria(entityData);
    } else if (mode === constants.SERVICE_MODE) {
      return serviceCriteria(entityData);
    } else if (mode === constants.MARKET_MODE) {
      return marketCriteria(entityData);
    } else if (mode === constants.MARKET_PRODUCT_GROUP_MODE) {
      return marketProductCriteria(entityData);
    } else if (mode === constants.SERVICE_MANAGEMENT) {
      return serviceManagementCriteria(entityData);
    }
    return [];
  };
  var getAdditionalParameters = function getAdditionalParameters(mode, entityData) {
    var additionalParameters;
    if (mode === constants.CABIN_MODE) {
      additionalParameters = legCabinParams(entityData);
    } else if (mode === constants.CLASS_MODE) {
      additionalParameters = legClassParams(entityData);
    } else if (mode === constants.SEGMENT_CLASS_MODE) {
      additionalParameters = segmentClassParams(entityData);
    } else if (mode === constants.SERVICE_MODE) {
      additionalParameters = serviceClassParams(entityData);
    } else if (mode === constants.MARKET_MODE) {
      additionalParameters = marketPointOfSaleParams(entityData);
    } else if (mode === constants.MARKET_PRODUCT_GROUP_MODE) {
      additionalParameters = marketClassGroupParams(entityData);
    } else {
      return undefined;
    }
    additionalParameters.eventTimeStamp = entityData.eventTimeStamp;
    return additionalParameters;
  };
  return {
    searchCriteriaFor: getSearchCriteria,
    additionalParametersFor: getAdditionalParameters
  };
};
AlertParametersFactory.$inject = ['DataRetrieverConstantsService', 'SearchCriteriaRuleFactory'];
module.exports = AlertParametersFactory;